// extracted by mini-css-extract-plugin
export default {"button":"_p-z","reviewSort":"aq-z"};